/* ============================================
   SOCIAL PROOF TOAST NOTIFICATIONS
   Shows fake-real purchase notifications
   ============================================ */
(function() {
  'use strict';

  const CITIES = [
    'Madrid', 'Barcelona', 'Sevilla', 'Valencia', 'Bilbao',
    'Lisboa', 'Porto', 'Bogotá', 'Ciudad de México', 'Buenos Aires',
    'Santiago', 'Lima', 'Quito', 'Montevideo', 'São Paulo',
    'Berlín', 'París', 'Roma', 'Ámsterdam', 'Londres'
  ];

  const NAMES = [
    'Carlos', 'María', 'Juan', 'Ana', 'Pedro',
    'Lucía', 'Diego', 'Sofía', 'Miguel', 'Valentina',
    'Andrés', 'Camila', 'Roberto', 'Isabella', 'Fernando',
    'Daniela', 'Pablo', 'Mariana', 'Alejandro', 'Gabriela'
  ];

  const TIMES = [
    'hace 2 minutos', 'hace 5 minutos', 'hace 8 minutos',
    'hace 12 minutos', 'hace 15 minutos', 'hace 20 minutos',
    'hace 25 minutos', 'hace 30 minutos', 'hace 1 hora', 'hace 2 horas'
  ];

  function getRandom(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function createToast() {
    // Remove existing toast
    const existing = document.querySelector('.social-proof-toast');
    if (existing) existing.remove();

    const name = getRandom(NAMES);
    const city = getRandom(CITIES);
    const time = getRandom(TIMES);

    const toast = document.createElement('div');
    toast.className = 'social-proof-toast';
    toast.innerHTML = `
      <div class="social-proof-toast__icon">⚽</div>
      <div class="social-proof-toast__text">
        <strong>${name}</strong> de ${city}<br>
        compró una camiseta ${time}
      </div>
      <button class="social-proof-toast__close" aria-label="Cerrar">&times;</button>
    `;

    document.body.appendChild(toast);

    // Close button
    toast.querySelector('.social-proof-toast__close').addEventListener('click', function() {
      toast.classList.remove('visible');
      setTimeout(() => toast.remove(), 400);
    });

    // Show
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        toast.classList.add('visible');
      });
    });

    // Auto-hide after 5s
    setTimeout(() => {
      if (toast.parentNode) {
        toast.classList.remove('visible');
        setTimeout(() => toast.remove(), 400);
      }
    }, 5000);
  }

  // Don't show on cart or checkout pages
  if (window.location.pathname.includes('/cart') || window.location.pathname.includes('/checkout')) {
    return;
  }

  // First toast after 8 seconds, then every 30-50 seconds
  setTimeout(function() {
    createToast();
    setInterval(function() {
      createToast();
    }, 30000 + Math.random() * 20000);
  }, 8000);

})();

/* ============================================
   COUNTDOWN TIMER
   Creates urgency with a promo countdown
   ============================================ */
(function() {
  'use strict';

  const bar = document.querySelector('.promo-countdown-bar');
  if (!bar) return;

  const timerEl = bar.querySelector('.promo-countdown-bar__timer');
  if (!timerEl) return;

  // Set end of today as deadline
  function getDeadline() {
    const now = new Date();
    const end = new Date(now);
    end.setHours(23, 59, 59, 999);
    return end;
  }

  function pad(n) { return n < 10 ? '0' + n : n; }

  function updateTimer() {
    const now = new Date();
    const deadline = getDeadline();
    const diff = deadline - now;

    if (diff <= 0) {
      timerEl.innerHTML = '<span>00</span>:<span>00</span>:<span>00</span>';
      return;
    }

    const h = Math.floor(diff / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);

    timerEl.innerHTML = `<span>${pad(h)}</span>:<span>${pad(m)}</span>:<span>${pad(s)}</span>`;
  }

  updateTimer();
  setInterval(updateTimer, 1000);
})();
